import SingleClientReportEntriesTableRow from './SingleClientReportEntriesTableRow';

export default SingleClientReportEntriesTableRow;


// WEBPACK FOOTER //
// ./src/features/reports/components/single-client/form/table/row/index.js